export var translateHorizontally = function (parent, to) { return function () {
    if (!parent)
        return;
    /* eslint-disable no-param-reassign */
    parent.style.transition = 'transform ease-in-out 0.3s';
    parent.style.transform = "translateX(" + -to + "px)";
    parent.addEventListener('transitionend', function () {
        parent.style.transition = '';
    });
    /* eslint-enable no-param-reassign */
}; };
export var scrollToTab = function (tabIndex) {
    var el = document.querySelector("[data-tab-id='" + tabIndex + "']");
    var parent = el === null || el === void 0 ? void 0 : el.parentElement;
    if (el && parent) {
        var lastButton = parent.querySelector('[data-tab-id]:last-child');
        var elWidth = el.offsetWidth;
        var parentWidth = parent.offsetWidth;
        var rightLimit = lastButton.offsetLeft - parentWidth + lastButton.offsetWidth;
        var targetX = ((tabIndex + 1) * elWidth) - (parentWidth / 2) - (elWidth / 2);
        if (targetX < 0)
            targetX = 0;
        if (targetX > rightLimit)
            targetX = rightLimit;
        window.requestAnimationFrame(translateHorizontally(parent, targetX));
    }
};
export var getTransformationValues = function (element) {
    var style = window.getComputedStyle(element);
    var matrix = style.transform || style.webkitTransform || style.mozTransform;
    // No transform property. Simply return 0 values.
    if (matrix === 'none' || typeof matrix === 'undefined') {
        return {
            x: 0,
            y: 0,
            z: 0,
        };
    }
    // Can either be 2d or 3d transform
    var matrixType = matrix.includes('3d') ? '3d' : '2d';
    var matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(', ');
    // 2d matrices have 6 values
    // Last 2 values are X and Y.
    // 2d matrices does not have Z value.
    if (matrixType === '2d') {
        return {
            x: matrixValues[4],
            y: matrixValues[5],
            z: 0,
        };
    }
    // matrixType === 3d
    return {
        x: matrixValues[12],
        y: matrixValues[13],
        z: matrixValues[14],
    };
};
export var smoothScrollTo = function (offset, currentX, scroller) {
    var nextValue = currentX - offset;
    /* eslint-disable no-param-reassign */
    scroller.style.transform = "translateX(" + nextValue + "px)";
};
